import { SET_CHILD_AGE_SLAB } from './actionTypes';

export const setAgeSlab = obj => {
  return {
    type: SET_CHILD_AGE_SLAB,
    payload: obj,
  };
};
